import {cva} from 'class-variance-authority';

export const rowItemStyles = cva(
    "",
    {
        variants: {
            color: {
                blue: 'bg-blue-100 hover:bg-blue-200',
                red: 'bg-red-100 hover:bg-red-200',
                white: 'bg-white hover:bg-gray-100',
            },
        },
        defaultVariants: {
            color: 'white',
        },
    },
);

export const getRowColor = (statusNumber: string, invcDays: number) => {
    if (statusNumber === "0" || statusNumber === "1") return 'blue';
    if ((statusNumber === "4" || statusNumber === "5") && invcDays > 120) return 'red';
    return 'white';
};